const languages = ['english', 'marathi', 'hindi', 'bengali', 'tamil', 'telugu', 'kannada'];

export default languages;